

module.exports = __webpack_require__.stylable.create(
    "EventHover1912213812",
    {"classes":{"root":"EventHover1912213812__root","EventHoverWrapper":"EventHover1912213812__EventHoverWrapper","EventHover":"EventHover1912213812__EventHover"},"vars":{},"stVars":{"EventCornerRadius":"'\"unit(fallback(--eventCornerRadius, 0), px)\"'","HoverColor":"\"fallback(color(color-5))\""},"keyframes":{}},
    "",
    18,
    "EventHover1912213812",
    null
);
